import React, { Component, Fragment } from 'react';
import RadioSelector from './selectors/Radio.jsx';

export default class RadioModifierContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: this.findDefaultSelected(),
            isHidden: this.findDefaultSelected() !== 0
        };
        this.generateJSXFromData = this.generateJSXFromData.bind(this);
        this.removeSelections = this.removeSelections.bind(this);
        this.select = this.select.bind(this);
        this.findDefaultSelected = this.findDefaultSelected.bind(this);
        this.show = this.show.bind(this);
    }

    findDefaultSelected() {
        let selectedMods = this.props.modifiers.filter( (val, ind, arr) => {
            const choice = this.props.choices[val];
            if(choice.quantity > 0) {
                return true;
            }
            return false;
        });
        if(selectedMods.length < 1) {
            //No selected mods set to 0
            return 0;
        }else {
            return selectedMods[0];
        }
    }

    generateJSXFromData() {
        var result = this.props.modifiers.map( (val, ind, arr) => {
            const mod = this.props.allModifiers[val];
            const choice = this.props.choices[val];
            return <RadioSelector select={this.select} selected={this.state.selected} key={ind} modifierKey={val} name={mod.name}
                setExtra={this.props.setExtra} setLight={this.props.setLight}
                setNormal={this.props.setNormal} choice={choice} showChangeSelectionBtn={this.props.showChangeSelectionBtn} />
        });

        return result;
    }

    removeSelections() {
        this.props.modifiers.map( (val, ind, arr) => {
            this.props.removeModifier(val);
        })
    }

    select(key) {
        this.removeSelections();
        this.setState({selected: key, isHidden: false}, ()=> {
            this.props.setWhole(key)
            this.props.selectRadio(this.props.radioIndex, key);
        });
    }

    show() {
        this.setState({isHidden: false});
    }

    render() {
        if(this.state.isHidden) {
            let chosenName = this.props.allModifiers[this.state.selected].name;
            return (
            <div className="row">
                <h4 className='m-3'>{this.props.name} <small>Selected: {chosenName}</small></h4>
                <div className="container text-center">
                    <a onClick={this.show} className="btn btn-primary">Change Selection</a>
                </div>
            </div>)
        }else {
            return (
                <div className="container-fluid special-radio">
                    {/*<h4 className='m-3'>{this.props.name} <small>(required)</small></h4>*/}
                    {/*<div className="row text-center">*/}
                        {/*{this.generateJSXFromData()}*/}
                    {/*</div>*/}
                    <label className="container">
                        {/*<div className="row">*/}
                        {this.generateJSXFromData()}
                        {/*</div>*/}
                    </label>
                    <hr className="p-1 m-auto" />
                </div>
            );
        }
    }
}